export default {
  GFPP: 'ec0e3f2e-3965-4716-b3a4-e5fc1f7a848f',
  TIMING_PANEL: 'b9365613-d1c8-417c-a905-9e4ed8d23fc0',
  TEXT_SETTINGS: '16647fae-4385-4591-b93f-74321b370bc0',
};
